.bio {
  font-size: 15px;
  color: var(--color-text-primary);
  unicode-bidi: plaintext;
  overflow-wrap: anywhere;

  p {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  :any-link {
    color: var(--color-text-status-links);

    &:hover {
      text-decoration: none;
    }
  }
}
